<template>
    <!-- TODO CHANGE  !disableParticipantSelection to disableParticipantSelection-->
    <div
        class="dropdown border-default bg-primary-white participants-dropdown"
        :disabled="disableParticipantSelection"
        ref="dropdownWrap"
        :class="{
            '': !capacity,
            '': capacity,
            'border-disabled': disableParticipantSelection
        }"
        id="dropdown-container"
    >
        <button
            id="participants-button"
            :disabled="disableParticipantSelection"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="align-items-center w-100 border-0 d-flex h-100 w-100 outline-none text-nowrap bg-primary-white line-height-0 position-absolute top-0 left-0 bg-none"
            :class="{
                'dropdown-toggle': !capacity
            }"
            ref="dropdown"
        >
            <ParticipantIcon></ParticipantIcon>
            <div
                class="subcaption text-primary-black content"
                :class="{ 'subcaption-strong': capacity, 'text-disabled': disableParticipantSelection }"
            >
                {{ capacity ? displayValue : store.contents.participants }}
            </div>
            <span class="justify-content-end flex-grow-1 arrow-down">
                <ArrowDown></ArrowDown>
            </span>

            <span class="justify-content-end flex-grow-1 arrow-up">
                <ArrowUp></ArrowUp>
            </span>
        </button>
        <div
            :style="{ width: dropdownWidth ? dropdownWidth : '100%' }"
            class="dropdown-menu shadow-4 p-3"
            @click.stop="handleCloseAllChildDropdowns()"
        >
            <div class="d-flex align-items-center justify-content-between">
                <div class="heading text-grey-900">
                    {{ store.contents.numParticipants }}
                </div>
                <button class="ts-x-black ts-x-md" @click="close"></button>
            </div>
            <div class="row align-items-center mt-3 mr-2">
                <div class="col-6 body text-grey-900 text-capitalize">
                    {{ store.contents.adults }}
                </div>
                <div class="col-6 d-flex justify-content-end align-items-center">
                    <div class="col-2 text-center">
                        <button class="ts-minus-blue" @click.stop="removePerson('adult')" :disabled="adults.length === 1"></button>
                    </div>
                    <div class="col-2 text-center body text-grey-900 mt-1">
                        <span>{{ adults.length }}</span>
                    </div>
                    <div class="col-2 text-center">
                        <button class="ts-plus-blue" @click.stop="addAdult()" :disabled="adults.length === adultsMaxNum"></button>
                    </div>
                </div>
            </div>
            <div class="row align-items-center mt-2 mb-3 mr-2">
                <div class="col-6 body text-grey-900 text-capitalize">
                    {{ store.contents.children }}
                </div>
                <div class="col-6 d-flex justify-content-end align-items-center">
                    <div class="col-2 text-center">
                        <button @click.stop="removePerson('child')" class="ts-minus-blue" :disabled="children.length === 0"></button>
                    </div>
                    <div class="col-2 text-center body text-grey-900 mt-1">
                        <span>{{ children.length }}</span>
                    </div>
                    <div class="col-2 text-center">
                        <button @click.stop="addChild()" class="ts-plus-blue" :disabled="children.length === childrenMaxNum"></button>
                    </div>
                </div>
            </div>
            <div class="mt-2 d-flex flex-column bg-blue-100 p-2 text-center caption text-start text-primary-blue children-start-age">
                <span class="caption-strong text-start">
                    <span>
                        <InfoIcon></InfoIcon>
                    </span>
                    <span>{{ store.contents.childrenAgeAtTheStartOfStay }}</span>
                </span>
                <span class="caption text-start mt-2">{{ store.contents.participantsSign }}</span>
            </div>
            <div class="mt-2 body text-grey-900" v-if="children.length > 0">
                {{ store.contents.childrenAge }}
            </div>
            <div class="d-flex flex-wrap mt-2 gap-2 ms-2" v-if="children.length > 0 && !disableParticipantSelection">
                <div
                    class="dropdown border-default bg-primary-white child-dropdown col-2 d-flex child-dropdown position-relative"
                    id="dropdown-container"
                    v-for="(child, index) in children"
                    @click.stop="handleClickOnChildDropDown(index, $event)"
                >
                    <span class="body text-grey-900 d-flex align-items-center w-100">
                        <span>{{ state.childDropdowns[index].value }}</span>
                        <span class="d-flex justify-content-end flex-grow-1 arrow-up" v-if="state.childDropdowns[index].isOpen">
                            <ArrowUp></ArrowUp>
                        </span>
                        <span class="d-flex justify-content-end flex-grow-1 arrow-down" v-else>
                            <ArrowDown></ArrowDown>
                        </span>
                    </span>
                    <div class="dropdown-menu child-dropdown-menu" :class="state.childDropdowns[index].isOpen && 'd-block open'">
                        <div
                            class="py-1 px-4 body text-primary-black cursor-pointer child-dropdown-menu-item"
                            v-for="(age, age_i) in ages"
                            :key="age + age_i"
                            @click.stop="setAge(index, age)"
                        >
                            <span class="body text-grey-900">
                                {{ age }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="participants-validate-button"
                class="button-primary primary-normal mt-2 cursor-pointer w-100 d-flex align-items-center justify-content-center"
                @click="apply"
            >
                {{ store.contents.saveParticipants }}
            </div>
        </div>
    </div>
</template>

<script>
// Components
import ArrowUp from '@se/components/svg/common/arrow-up/index.vue'
import ArrowDown from '@se/components/svg/common/arrow-down/index.vue'
import ParticipantIcon from '@se/components/svg/se/participants/index.vue'
import InfoIcon from '@se/components/svg/common/info/index.vue'
import { onClickOutside } from '@vueuse/core'

// Config

import bockedParticipantCompanies from '@se/config/blocked-participant-companies'

import * as ParticipantsAges from 'tf-participants-ages'

import { emitParticipantsValue, setParticipantsValueListener } from '../../logic/globalizeValues'

export default {
    name: 'Participants',
    components: {
        // FontAwesomeIcon
        ArrowUp,
        ArrowDown,
        ParticipantIcon,
        InfoIcon
    },
    props: {
        store: Object,
        control: Object,
        classesToggle: Object,
        dropdownWidth: String
        // values: Array, // sorted asc capacity criterias
    },
    data: function () {
        return {
            data: {
                adultAge: 18,
                childAge: 12,
                participantsAgesInit: [],
                participantsAges: []
            },
            state: {
                childDropdowns: [],
                isDropdownOpen: false
            }
        }
    },
    computed: {
        capacity: function () {
            var capacityId = this.store.data.selected.capacity
            if (!capacityId) {
                return null
            }
            var capacity = this.store.getCapacityById(capacityId)
            return capacity
        },
        maxCapacity: function () {
            var capacityId = this.store.data.available.capacity.slice(-1)[0]
            if (!capacityId) {
                return null
            }
            var capacity = this.store.getCapacityById(capacityId)
            return capacity
        },
        adultsMaxNum: function () {
            if (!this.maxCapacity) {
                return null
            }
            return this.maxCapacity.value - this.children.length
        },
        childrenMaxNum: function () {
            if (!this.maxCapacity) {
                return null
            }
            return this.maxCapacity.value - this.adults.length
        },
        adults: function () {
            return this.data.participantsAges.filter((age) => age >= this.data.adultAge)
        },
        children: function () {
            return this.data.participantsAges.filter((age) => age < this.data.adultAge)
        },
        adultsInit: function () {
            return this.data.participantsAgesInit.filter((age) => age >= this.data.adultAge)
        },
        childrenInit: function () {
            return this.data.participantsAgesInit.filter((age) => age < this.data.adultAge)
        },
        ages: function () {
            var ages = []
            for (var i = 1; i <= this.data.adultAge - 1; i++) {
                ages.push(i)
            }
            return ages
        },
        displayValue: function () {
            const numOfAdults = this.adultsInit.length,
                numOfChilds = this.childrenInit.length
            const adultStr = numOfAdults === 1 ? this.store.contents.adult : this.store.contents.adults
            const childStr = numOfChilds === 1 ? this.store.contents.child : this.store.contents.children
            return numOfAdults + ' ' + adultStr + (numOfChilds > 0 ? ', ' + numOfChilds + ' ' + childStr : '')
        },
        isDefault: function () {
            return this.data.participantsAgesInit.length === 2 && this.data.participantsAgesInit[0] === 18 && this.data.participantsAgesInit[0] === 18
        },
        registeredChildrenDropdowns() {
            return this.state.childDropdowns.filter((item) => item.isRegistered)
        },
        disableParticipantSelection() {
            const formattedLocale = this.store.state.locale.replace(/-/g, '_')
            const { company } = this.store.data
            return formattedLocale === 'fr_FR_CSE' && bockedParticipantCompanies.has(company)
        }
    },
    methods: {
        init() {
            var participantsAges = ParticipantsAges.get()
            var capacityId = this.store.data.selected.capacity
            var value = this.store.data.fields.capacity.find(function (value) {
                return value.id === capacityId
            })

            if (this.disableParticipantSelection) {
                this.getTravelerCompanionsCookieData()
                return
            }

            var capacity = value ? value.value : null

            capacity = capacity || participantsAges.length
            capacity = capacity === 0 ? 2 : capacity

            if (participantsAges.length < capacity) {
                var diff = capacity - participantsAges.length
                for (var i = 0; i < diff; i++) {
                    participantsAges.push(this.data.adultAge)
                }
            }

            if (participantsAges.length > capacity) {
                var diff = participantsAges.length - capacity
                participantsAges.splice(diff)
            }
            if (this.adults.length === 0) {
                participantsAges[0] = this.data.adultAge
            }
            var participantsAgesInit = []
            participantsAges.forEach((age) => {
                participantsAgesInit.push(age)
            })

            this.data.participantsAgesInit = participantsAgesInit
            this.data.participantsAges = participantsAges
        },
        getCapacityByValue(_value) {
            var capacity = this.store.data.fields.capacity.find(function (value) {
                return value.value === _value
            })
            return capacity
        },
        addAdult() {
            this.data.participantsAges.push(this.data.adultAge)
        },
        addChild() {
            this.data.participantsAges.push(this.data.childAge)
            this.addChildDropDown()
            this.handleCloseAllChildDropdowns()
        },
        removePerson(type) {
            var self = this
            var participantsAges = [...this.data.participantsAges]
            participantsAges.reverse()
            var index = participantsAges.findIndex(function (age) {
                return type === 'adult' ? age >= self.data.adultAge : age < self.data.adultAge
            })
            participantsAges.splice(index, 1)
            participantsAges.reverse()
            this.data.participantsAges = participantsAges
            this.handleCloseAllChildDropdowns()
        },
        setAge(childIndex, newAge) {
            var self = this
            var _childIndex = -1
            var index = this.data.participantsAges.findIndex(function (age) {
                if (age < self.data.adultAge) {
                    _childIndex++
                }
                return _childIndex === childIndex
            })
            this.data.participantsAges[index] = newAge
            this.toggleChildDropdownOpen(childIndex)
            this.setChildDropdownValue(childIndex, newAge)
        },
        apply() {
            ParticipantsAges.set(this.data.participantsAges)
            var capacity = this.getCapacityByValue(this.data.participantsAges.length)
            this.store.libs.se.setFieldValue('capacity', capacity.id)
            this.init()
            $(this.$refs.dropdown).dropdown('hide')
            this.registerAllChildDropdowns()
            emitParticipantsValue() // this is for the case when there are several search engine UIs on the page
        },
        close() {
            $(this.$refs.dropdown).dropdown('hide')
        },
        clear() {
            this.data.participantsAges = [this.data.adultAge, this.data.adultAge]
            this.apply()
        },
        showDropdown() {
            $(this.$refs.dropdown).dropdown('show')
        },
        addChildDropDown() {
            this.state.childDropdowns.push({
                isOpen: false,
                isRegistered: false,
                value: this.data.childAge
            })
        },
        removeChildDropDown(index) {
            if (typeof index === 'undefined') throw new Error('index is mandatory in removeChildDropDown')
            this.state.childDropdowns.reverse()
            this.state.childDropdowns.splice(index, 1)
        },
        handleClickOnChildDropDown(index, event) {
            this.toggleChildDropdownOpen(index)
            const filteredChildDropdowns = this.state.childDropdowns.filter((dropdown) => {
                return this.state.childDropdowns.indexOf(dropdown) !== index
            })

            this.handleCloseListOfChildDropdowns(filteredChildDropdowns)

            setTimeout(() => {
                const windowHeight = window.innerHeight
                const openChildMenu = document.querySelector('.child-dropdown-menu.open')
                const openChildMenuBoundingRect = openChildMenu.getBoundingClientRect()

                if (openChildMenuBoundingRect.bottom > windowHeight) {
                    openChildMenu.classList.add('absolute-child-dropdown')
                }
            }, 50)
        },
        toggleChildDropdownOpen(index) {
            if (typeof index === 'undefined') throw new Error('dropdown index is mandatory in toggleChildDropdownOpen')

            this.state.childDropdowns[index].isOpen = !this.state.childDropdowns[index].isOpen
        },
        setChildDropdownValue(index, value) {
            if (typeof index === 'undefined') throw new Error('dropdown index is mandatory in toggleChildDropdownOpen')
            if (typeof value === 'undefined') throw new Error('dropdown value is mandatory in toggleChildDropdownOpen')
            this.state.childDropdowns[index].value = value
        },
        filterUnRegisteredChildDropdowns() {
            this.state.childDropdowns = this.state.childDropdowns.filter((item) => item.isRegistered)
        },
        registerAllChildDropdowns() {
            this.state.childDropdowns.forEach((item) => (item.isRegistered = true))
        },
        initChildrenDropdowns() {
            this.children.forEach((child) => {
                this.state.childDropdowns.push({
                    isOpen: false,
                    isRegistered: true,
                    value: child
                })
            })
        },

        handleCloseAllChildDropdowns() {
            this.state.childDropdowns.forEach((dropdown) => (dropdown.isOpen = false))
        },
        handleCloseListOfChildDropdowns(childDropdowns) {
            if (!childDropdowns) throw new Error('childDropdowns are mandatory in handleCloseListOfChildDropdowns')
            childDropdowns.forEach((dropdown) => (dropdown.isOpen = false))
        },
        setIsDropDownOpen(isDropdownOpen) {
            if (typeof isDropdownOpen === 'undefined') throw new Error('isDropdownOpen is mandatory in setIsDropDownOpen')
            this.state.isDropdownOpen = isDropdownOpen
        },
        getCookie(cookieName) {
            const cookieObj = Object.fromEntries(
                document.cookie.split(/;\s*/).map(function (cookie) {
                    const arr = cookie.split('=')
                    const key = decodeURIComponent(arr[0])
                    const value = decodeURIComponent(arr[1])
                    return [key, value]
                })
            )

            return cookieObj[cookieName]
        },
        getTravelerCompanionsCookieData() {
            const travelerCompanions = this.getCookie('travelerCompanions')
            if (!travelerCompanions) throw new Error('travelerCompanions is mandatory in getTravelerCompanionsCookieData')
            const travelerCompanionsData = JSON.parse(travelerCompanions)
            const selectedParticipants = travelerCompanionsData.travalers.filter((traveler) => traveler.isSelected || traveler.isMain)
            const participantAges = selectedParticipants.map((traveler) => {
                if (!traveler.age) return 18
                return traveler.age
            })
            this.data.participantsAgesInit = participantAges
            this.data.participantsAges = participantAges
            ParticipantsAges.set(this.data.participantsAges)
            var capacity = this.getCapacityByValue(this.data.participantsAges.length)
            this.store.libs.se.setFieldValue('capacity', capacity.id)
            return participantAges
        }
    },
    beforeDestroy: function () {
        $(this.$refs.dropdown).dropdown('dispose')
    },
    mounted() {
        $(window).on('click', () => {
            this.handleCloseAllChildDropdowns()
        })

        var self = this
        this.store.libs.se.onFieldValue(
            'capacity',
            function () {
                self.init()
            },
            true
        )

        this.control.on('show', function () {
            self.showDropdown()
        })

        this.control.on('hide', function () {
            $(self.$refs.dropdown).dropdown('hide')
        })
        var dropdownWrap = $(this.$refs.dropdownWrap)
        dropdownWrap.on('show.bs.dropdown', function () {
            try {
                self.init()
                self.$emit('show')
            } catch (e) {}
        })
        dropdownWrap.on('shown.bs.dropdown', function () {
            self.$emit('shown')
            setTimeout(function () {
                // $(self.$refs.dropdownWrap).addClass('show')
            }, 1000)
        })
        dropdownWrap.on('hide.bs.dropdown', function () {
            self.$emit('hide')
        })
        dropdownWrap.on('hidden.bs.dropdown', function () {
            self.$emit('hidden')
        })

        window.addEventListener('closeMonCompteModal', () => {
            this.getTravelerCompanionsCookieData()
        })

        this.initChildrenDropdowns()

        setParticipantsValueListener(() => {
            // this is for the case when there are several search engine UIs on the page
            this.init()
            this.initChildrenDropdowns()
        })

        onClickOutside(this.$refs.dropdownWrap, () => {
            $(this.$refs.dropdown).dropdown('hide')
        })
    }
}
</script>

<style scoped>
.children-start-age {
    border-radius: 8px;
    padding: 12px 19px;
}

.child-dropdown-menu {
    min-width: 70px;
}

.child-dropdown-menu {
    max-height: 30vh;
    overflow: scroll;
}
.arrow-down,
.arrow-up {
    z-index: 1;
}

.absolute-child-dropdown {
    top: -175px !important;
    position: absolute;
    left: 0 !important;
}

.arrow-up {
    display: flex;
}

.arrow-down {
    display: none;
}

.participants-dropdown.show .arrow-down {
    display: flex;
}

.participants-dropdown.show .arrow-up {
    display: none;
}
</style>
